import personalProfileActions from './personalProfileActions';
import $api from 'http/index';
import { setItem } from 'helpers/localStorage';
import { getTimeZone } from 'helpers/getTimeZone';
import availabilityPageActions from 'store/availability/availabilityPageActions';
import { format } from 'date-fns';
import { getOptions } from 'helpers/getOptions';
import { throwIfPtoConflict } from 'helpers/userUpdate';
import settingsAction from 'store/settings/settingsAction';

const catchError = (error) => {
  if (error.response) {
    if (Array.isArray(error.response.data.message))
      throw new Error(error.response.data.message.join('\n'));
    else throw new Error(error.response.data.message);
  } else {
    throw new Error(error.message);
  }
};

export const fetchPersonalProfile = () => async (dispatch) => {
  const options = {
    headers: {
      'X-Auth-Token': localStorage.getItem('authorization-token'),
    },
  };

  try {
    dispatch(personalProfileActions.setLoading(true));
    const response = await $api.get(`${process.env.REACT_APP_BASE_URL}/personal-profile`, options);

    setItem('userId', response.data._id);
    dispatch(personalProfileActions.getPersonalProfile(response.data));
    dispatch(
      availabilityPageActions.setDate(
        format(new Date(), response.data.organization.settings.dateFormat)
      )
    );
    dispatch(personalProfileActions.setLoading(false));
  } catch (error) {
    catchError(error);
  }
};

export const patchPersonalProfile = (data, isForcePTO = false) => async (dispatch) => {
  const options = {
    headers: {
      'X-Auth-Token': localStorage.getItem('authorization-token'),
    },
  };

  try {
    dispatch(personalProfileActions.setLoading(true));
    const response = await $api.patch(
      `${process.env.REACT_APP_BASE_URL}/personal-profile`,
      { ...data, ...(isForcePTO ? { isForcePTO: true } : {}) },
      options
    );

    dispatch(personalProfileActions.updatePersonalProfile(response.data));
  } catch (error) {
    throwIfPtoConflict(error);
    catchError(error);
  } finally {
    dispatch(personalProfileActions.setLoading(false));
  }
};

export const changePasswordPersonalProfile = async (password, currentPassword) => {
  const options = {
    headers: {
      'X-Auth-Token': localStorage.getItem('authorization-token'),
    },
  };
  
  const data = {
    password,
    currentPassword,
  };
  
  try {
    await $api.post(
      `${process.env.REACT_APP_BASE_URL}/personal-profile/change-password`,
      data,
      options
    );
  } catch (error) {
    catchError(error);
  }
};

const EMAIL_CHANGE_URL = `${process.env.REACT_APP_BASE_URL}/personal-profile/email-change`;

const updateEmailChange = (request) => async (dispatch) => {
  try {
    const { data } = await request(getOptions());
    dispatch(personalProfileActions.updatePersonalProfile(data));
    return data;
  } catch (error) {
    catchError(error);
  }
};

export const requestEmailChange = (email, currentPassword) =>
  updateEmailChange((options) => $api.post(EMAIL_CHANGE_URL, { email, currentPassword }, options));

export const resendEmailChange = () =>
  updateEmailChange((options) => $api.post(`${EMAIL_CHANGE_URL}/resend`, {}, options));

export const cancelEmailChange = () =>
  updateEmailChange((options) => $api.delete(EMAIL_CHANGE_URL, options));

export const loginToLocation = (locationId) => async (dispatch) => {
  const options = getOptions();

  try {
    const response = await $api.post(
      `${process.env.REACT_APP_BASE_URL}/personal-profile/login-to-location`,
      { tenantLocationId: locationId },
      options
    );

    dispatch(personalProfileActions.updatePersonalProfile(response.data));
    if (response?.data?.organization) {
      dispatch(personalProfileActions.setOrganization(response.data?.organization));
    }
    if (response?.data?.organizationLocation) {
      dispatch(personalProfileActions.setOrganizationLocation(response.data?.organizationLocation));
    }
  } catch (error) {
    catchError(error);
  }
};
